import { AddCreditCard as AddCreditCardContainer } from "@/containers/profile/add-credit-card";

export default function AddCreditCard() {
  return <AddCreditCardContainer />;
}
